import api from "./api";
import type {
  CommonCode,
  CommonCodeGroup,
  CommonCodeCreateRequest,
  CommonCodeUpdateRequest,
  CommonCodeGroupCreateRequest,
  CommonCodeGroupUpdateRequest,
  CommonCodeOption,
} from "@/types/admin";

export const commonCodeService = {
  // === 공통코드 그룹 관리 ===

  // 그룹 목록 조회
  async getGroups(isActive?: boolean): Promise<CommonCodeGroup[]> {
    const response = await api.get<CommonCodeGroup[]>("/common-codes/groups", {
      params: isActive !== undefined ? { is_active: isActive } : undefined,
    });
    return response.data;
  },

  // 그룹 상세 조회 (코드 포함)
  async getGroup(groupId: number): Promise<CommonCodeGroup> {
    const response = await api.get<CommonCodeGroup>(`/common-codes/groups/${groupId}`);
    return response.data;
  },

  // 그룹 생성
  async createGroup(data: CommonCodeGroupCreateRequest): Promise<CommonCodeGroup> {
    const response = await api.post<CommonCodeGroup>("/common-codes/groups", data);
    return response.data;
  },

  // 그룹 수정
  async updateGroup(groupId: number, data: CommonCodeGroupUpdateRequest): Promise<CommonCodeGroup> {
    const response = await api.put<CommonCodeGroup>(`/common-codes/groups/${groupId}`, data);
    return response.data;
  },

  // 그룹 삭제
  async deleteGroup(groupId: number): Promise<void> {
    await api.delete(`/common-codes/groups/${groupId}`);
  },

  // === 공통코드 관리 ===

  // 코드 생성
  async createCode(groupId: number, data: CommonCodeCreateRequest): Promise<CommonCode> {
    const response = await api.post<CommonCode>(`/common-codes/groups/${groupId}/codes`, data);
    return response.data;
  },

  // 코드 수정
  async updateCode(codeId: number, data: CommonCodeUpdateRequest): Promise<CommonCode> {
    const response = await api.put<CommonCode>(`/common-codes/codes/${codeId}`, data);
    return response.data;
  },

  // 코드 삭제
  async deleteCode(codeId: number): Promise<void> {
    await api.delete(`/common-codes/codes/${codeId}`);
  },

  // 코드 순서 변경
  async reorderCodes(groupId: number, codeIds: number[]): Promise<CommonCode[]> {
    const response = await api.put<CommonCode[]>(`/common-codes/groups/${groupId}/codes/reorder`, codeIds);
    return response.data;
  },

  // === 드롭다운 옵션 조회 ===

  // 특정 그룹의 활성화된 코드 목록 조회 (드롭다운용)
  async getCodeOptions(groupCode: string): Promise<CommonCodeOption[]> {
    const response = await api.get<CommonCodeOption[]>(`/common-codes/groups/${groupCode}/options`);
    return response.data;
  },

  // === USER_TYPE 전용 헬퍼 함수 ===

  /**
   * USER_TYPE 공통코드 옵션 조회
   * @returns USER_TYPE 옵션 목록 (code: 'employee', value: '직원' 형식)
   */
  async getUserTypeOptions(): Promise<CommonCodeOption[]> {
    return this.getCodeOptions("USER_TYPE");
  },
};

export default commonCodeService;
